import { Checkbox as CheckboxPrimitive } from "radix-ui";
import React from "react";

import { cn } from "~/components/ui/cn";
import { CheckIcon } from "~/components/ui/icons/check";
import { MinusIcon } from "~/components/ui/icons/minus";

const Checkbox: React.FC<
  React.ComponentProps<typeof CheckboxPrimitive.Root>
> = ({ className, ...props }) => {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer size-5 cursor-pointer rounded-[2px] border-[1px] border-gray-600 text-white outline-0 transition duration-300 focus:ring-2 focus:ring-gray-900/30 disabled:cursor-not-allowed disabled:border-gray-300 data-[state=checked]:border-green-900 data-[state=indeterminate]:border-green-900 data-[state=checked]:bg-green-900 data-[state=indeterminate]:bg-green-900 data-[state=checked]:focus:ring-2 data-[state=indeterminate]:focus:ring-2 data-[state=checked]:focus:ring-green-900/30 data-[state=indeterminate]:focus:ring-green-900/30 data-[state=checked]:disabled:border-gray-300 data-[state=indeterminate]:disabled:border-gray-300 data-[state=checked]:disabled:bg-gray-300 data-[state=indeterminate]:disabled:bg-gray-300",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none [&>svg]:size-3.5"
      >
        {(props.defaultChecked ?? props.checked) === "indeterminate" ? (
          <MinusIcon className="size-4" />
        ) : null}
        {(props.defaultChecked ?? props.checked) === true ? (
          <CheckIcon className="size-4" />
        ) : null}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};

export { Checkbox };
